import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
import { splitState } from '../state';

const RANGES = ['all', 'month', 'year'];

/**
 * Typo notice ("did you mean") and the date filter, shown above the list.
 */
export default class SplitSearchExtras extends Component {
  view() {
    return (
      <div className="SplitSearch-extras">
        {this.notice()}
        {app.forum.attribute('splitSearchDateFilter') === false ? null : this.dateFilter()}
      </div>
    );
  }

  dateFilter() {
    return (
      <div className="SplitSearch-filters">
          <span className="SplitSearch-filterLabel">{app.translator.trans('happydigital-split-search.forum.filter.range')}</span>
          {RANGES.map((range) => (
            <Button
              className={'Button Button--link SplitSearch-chip' + (splitState.range === range ? ' active' : '')}
              onclick={() => {
                splitState.range = range;
                app.discussions.refresh();
                app.splitComments && app.splitComments.reload();
              }}
            >
              {app.translator.trans(`happydigital-split-search.forum.filter.range_${range}`)}
            </Button>
          ))}
      </div>
    );
  }

  notice() {
    if (!splitState.fuzzy) return null;

    const { suggestion } = splitState;

    return (
      <p className="SplitSearch-notice">
        {suggestion
          ? app.translator.trans('happydigital-split-search.forum.page.did_you_mean', {
              query: this.attrs.query,
              suggestion: <Link href={app.route('index', { q: suggestion })}>{suggestion}</Link>,
            })
          : app.translator.trans('happydigital-split-search.forum.page.similar_results', { query: this.attrs.query })}
      </p>
    );
  }
}
